module.exports = __webpack_public_path__ + "img/yishanglv.97b9055c.png";